import useCheckoutStore from "../store/checkoutStore";
import useSession from "../../services/state/session/useSession";
import useValueChangeListener from "../../services/state/general/useValueChangeListener";

const useCartLoader = () => {

    const session = useSession();
    const orderID = useCheckoutStore(state => state.orderID);
    const getCart = useCheckoutStore(state => state.getCart);
    const loadingOrder = useCheckoutStore(state => state.loading.cart);
    const error = useCheckoutStore(state => state.error.cart);

    useValueChangeListener(() => {
        if(session.isSignedIn && orderID <= 0 && !loadingOrder && !error)
            getCart(session);
    }, [session.isSignedIn], [])

}

export default useCartLoader;